import { Component, OnInit, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA, MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { GlobalConstants } from '../../../common/global-variable';
import { DomSanitizer, SafeUrl } from '@angular/platform-browser';
import { AlertComponent } from '../alert/alert.component';
import { AbstractControl, UntypedFormControl } from '@angular/forms';
import { ImageProcessComponent } from '../image-process/image-process.component';

@Component({
  selector: 'app-select-background',
  templateUrl: './select-background.component.html',
  styleUrls: ['./select-background.component.scss']
})
export class SelectBackgroundComponent implements OnInit {

  constructor(
    public matDialog: MatDialog,
    public dialogRef: MatDialogRef<SelectBackgroundComponent>,
    @Inject(MAT_DIALOG_DATA) public modalData: any,
    private sanitizer: DomSanitizer
  ) { }

  selectedImg
  initPrivate = false
  imgList
  mini_imgList
  treeType
  type = 'public'
  backgroundColorCtr: AbstractControl = new UntypedFormControl(null);

  ngOnInit(): void {

    if (this.modalData == '1' || this.modalData == '2') {
      this.imgList = GlobalConstants.portrait_background
      this.mini_imgList = GlobalConstants.portrait_background_mini
      this.treeType = "portrait"
    } else {
      this.imgList = GlobalConstants.landscape_background
      this.mini_imgList = GlobalConstants.landscape_background_mini
      this.treeType = "landscape"
    }
    this.selectedImg = this.imgList[0]
  }

  sanitizeImageUrl(imageUrl: string): SafeUrl {
    return this.sanitizer.bypassSecurityTrustUrl(imageUrl);
  }

  changeType(type) {
    this.type = type
  }

  setBackground() {
    const type = this.treeType
    const dialogConfig = new MatDialogConfig();
    // The user can't close the dialog by clicking outside its body
    dialogConfig.disableClose = true;
    dialogConfig.maxHeight = '90vh';
    dialogConfig.id = "image-process-component";
    dialogConfig.data = {
      type: type
    }
    const modalDialog = this.matDialog.open(ImageProcessComponent, dialogConfig);
    modalDialog.afterClosed().subscribe((imgResult) => {
      if (imgResult) {
        var img = new Image();
        img.src = imgResult;
        this.initPrivate = true
        if (type == "portrait") {
          if (img.width / img.height > 0.75 || img.width / img.height < 0.65) {
            const dialogConfig = new MatDialogConfig();
            // The user can't close the dialog by clicking outside its body
            dialogConfig.disableClose = true;
            dialogConfig.id = "alert-component";
            dialogConfig.data = {
              title: 'Alert', message: "This image doesn't fit for this tree. Are you sure you want to use this image? (Image size should be similar with 0.7(width : height))"
            }
            const modalDialog = this.matDialog.open(AlertComponent, dialogConfig);
            modalDialog.afterClosed().subscribe((result) => {
              if (result == 'success') {
                this.selectedImg = imgResult;
              }
            });

          } else {
            this.selectedImg = imgResult;
          }
        } else {
          if (img.height / img.width > 0.75 || img.height / img.width < 0.65) {

            const dialogConfig = new MatDialogConfig();
            // The user can't close the dialog by clicking outside its body
            dialogConfig.disableClose = true;
            dialogConfig.id = "alert-component";
            // dialogConfig.height = "90vh";
            dialogConfig.data = {
              title: 'Alert',
              message: "This image doesn't fit for this tree. Are you sure you want to use this image? (Image size should be similar with 0.7(height : width))"
            }
            const modalDialog = this.matDialog.open(AlertComponent, dialogConfig);
            modalDialog.afterClosed().subscribe((result) => {
              if (result == 'success') {
                this.selectedImg = imgResult;
              }
            });

          } else {
            this.selectedImg = imgResult;
          }
        }
      }
    });
  }

  selectImage(index) {
    this.selectedImg = this.imgList[index]
  }

  closeModal() {
    this.dialogRef.close();
  }

}
